export const defaultUrl =
  'https://backend.staging.bim.flykube.agifly.cloud/api/v1/'
export const assetsUrl = 'https://backend.staging.bim.flykube.agifly.cloud'

export const getAllProjects = `${defaultUrl}web/project`
export const sendContactApi = `${defaultUrl}web/project/contact`
